import React, { Component } from "react";

export default class SVG extends Component {
  constructor() {
    super();
    this.state = {
      width: 0,
      height: 0
    };
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight
    });
    // is called multiple times, not a big problem but definitely a small one.
    if (this.props.fitToScreen) 
      window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize, false);
  }

  handleResize() {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }

  render() {
    return (
      <svg
        id={this.props.id}
        width={this.props.width ? this.props.width : this.state.width}
        height={this.props.height ? this.props.height : this.state.height}
        viewBox={this.props.viewBox ? this.props.viewBox : null}
      >
        {this.props.children}
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SVG.js